import {UIComponent} from "@webfruits/core";
import {CoreAssets} from "../../../core/CoreAssets";
import {Size} from "../../../style/Size";
import {CoreServices} from "../../../core/CoreServices";
import {gsap} from "gsap";
import {AppConfig} from "../../../config/AppConfig";

/******************************************************************
 * Woman
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class Woman extends UIComponent {

    /******************************************************************
     * Properties
     *****************************************************************/

    private _image: UIComponent<HTMLImageElement>;

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(private _core: CoreServices) {
        super("woman-illustration");
        this.initImage();
        this._core.state.SELECTED_HOTSPOT.onChangeSignal.add(() => this.onSelectedHotspotChanged());
    }

    /******************************************************************
     * Public Methodes
     *****************************************************************/

    public playIntroAnimation() {
        gsap.from(this.transform, {
            duration: 0.7,
            scale: 0.5,
            alpha: 0,
            ease: "power4.out"
        })
    }

    public updateStyles() {
        this.applyStyle({
            position: "absolute",
            pointerEvents: "none",
            touchAction: "none",
            userSelect: "none",
            webkitTouchCallout: "none",
            left: "50%",
            top: "57%",
            z: -100
        })
        this._image.applyStyle({
            position: "absolute",
            objectFit: "contain",
            height: Size.APP_HEIGHT * 0.85,
            x: "-50%",
            y: "-50%"
        })
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initImage() {
        this._image = new UIComponent<HTMLImageElement>("img");
        this._image.view.src = CoreAssets.WOMAN;
        this.addChild(this._image);
    }

    private playShowAnimation() {
        gsap.to(this.view, {
            duration: AppConfig.HOTSPOT_SELECT_DURATION,
            alpha: 1,
            scale: 1,
            ease: "power4.out"
        })
    }

    private playHideAnimation() {
        gsap.to(this.view, {
            duration: AppConfig.HOTSPOT_SELECT_DURATION,
            scale: 0.8,
            alpha: 0,
            ease: "power4.out"
        })
    }

    /******************************************************************
     * Events
     *****************************************************************/

    private onSelectedHotspotChanged() {
        if (this._core.state.SELECTED_HOTSPOT.hasValue()) {
            this.playHideAnimation();
        } else {
            this.playShowAnimation();
        }
    }

}
